import { Box, styled, Typography } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.75),
}));

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center',
}));


const StyledLinkSpan = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '0.875rem',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));

const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(0.75),
  marginBottom: theme.spacing(0.5),
}));

const Field = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '30%',
});

const Label = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '0.875rem',
});

const LabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

const Value = styled(Typography)({
  fontSize: '0.875rem',
});

const MutedValue = styled(Value)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

const StatusBadge = styled(Box)({
  backgroundColor: '#d4f4dd',
  color: '#3b8c4a',
  fontWeight: 600,
  fontSize: '0.7rem',
  borderRadius: 6,
  padding: '2px 8px',
  display: 'inline-block',
  marginTop: 2,
  width: 'fit-content',
});

const UserSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: '0.25rem',
});

const FinancialFieldsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
}));

const PersonnelRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  '& > *:first-of-type': {
    gridColumn: '1',
  },
  '& > *:last-of-type': {
    gridColumn: '2',
  },
}));

const FinancialField = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.125rem',
});

const ToggleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

export { Container, Row, HeaderRow, Field, Label, Value, MutedValue, StatusBadge, UserSection, StyledLinkSpan, LabelRow, FinancialFieldsGrid, FinancialField, PersonnelRow, ToggleContainer };
